import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import UserLevel from "../../components/Security/UserLevel/UserLevel";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const UserLevelPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>User Level</VolunteerHeading>
      <UserLevel />
    </MainDiv>
  );
};

export default UserLevelPage;
